import { useParams } from "@tanstack/react-router";
import { MailView } from "./MailView";

/** Keys MailView by folder so per-folder state starts fresh on every folder change. */
export function MailRoute() {
  const { folder } = useParams({ from: "/shell/mail/$folder" });
  return <MailView key={folder} folder={folder} />;
}
